import {lazy} from "react";

export const BoardsLazy = lazy(() => import('./Boards'))